import HmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';
import moment from 'moment';

export const generateString = (reqMethod, id, timeStamp, fromGigya) => {
    const stringVal = fromGigya ? `${import.meta.env.VITE_SET_APIGEE_GIGYA_SECRETKEY}` : `${import.meta.env.VITE_SET_APIGEE_SECRETKEY}`;
    let customStr = reqMethod + id + timeStamp;
    let customStrVal = Base64.stringify(HmacSHA256(customStr, stringVal));
    return customStrVal;
};

export const getCurrentServerTimeStamp = format => {
    const serverTimeStampReq = new XMLHttpRequest();
    let serverTimeStamp;
    serverTimeStampReq.onload = () => {
        const dateHeader = serverTimeStampReq.getResponseHeader('Date');
        serverTimeStamp = moment.utc(new Date(dateHeader)).format(format);
    }
    serverTimeStampReq.open("HEAD", window.location.href, false);
    serverTimeStampReq.send();
    return serverTimeStamp;
}